module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5bfff9bf12488459f68ffb3428d8dcb5.png";